module.exports = __webpack_public_path__ + "6306843836e0390a7a83cf29092a0f63.svg";